import { IColorUserV1 } from '../tools/api.service';
import { Injectable } from "@angular/core";

@Injectable()
export class ColorUser {
  idcolorUser?: number;
  mail?: string;
  password?: string;
  name?: string;
  firstname?: string;
  phone?: string;
  mobilePhone?: string;
  socialReason?: string;
  address?: string;
  postalCode?: string;
  city?: string;
  businessCode?: string;
  customerCode?: string;
  cityRenault?: string;
  country?: string;
  language?: string;
  accepted?: number;
  refusal?: string;
  activationDate?: string;
  haveScale?: number;
  scaleType?: number;
  paintBrand?: string;
  mrpAccount?: string;

  public static parseToColorUser(item: ColorUser): IColorUserV1 {
    let result = new IColorUserV1();
    result.idcolorUser = item.idcolorUser;
    result.mail = item.mail;
    result.password = item.password;
    result.name = item.name;
    result.firstname = item.firstname;
    result.phone = item.phone;
    result.mobilePhone = item.mobilePhone;
    result.socialReason = item.socialReason;
    result.address = item.address;
    result.postalCode = item.postalCode;
    result.city = item.city;
    result.businessCode = item.businessCode;
    result.customerCode = item.customerCode;
    result.cityRenault = item.cityRenault;
    result.country = item.country;
    result.language = item.language;
    result.accepted = item.accepted;
    result.refusal = item.refusal;
    result.activationDate = item.activationDate;
    result.haveScale = item.haveScale;
    result.scaleType = item.scaleType;
    result.paintBrand = item.paintBrand;
    result.mrpAccount = item.mrpAccount;
    return result;
  }
}
